/* global localData */
const steps = document.querySelectorAll('div.steps-process');
const loading = document.querySelector('.site-loader');
const orderPerks = ['input[name="delivery"]', 'input[name="delivery-type"]', '#invoice'];

const addClassAndValue = (selector, value) => {
  const addressInput = document.querySelector(selector);
  addressInput.closest('.mod-input').classList.add('is-focused');
  addressInput.value = value;
};
const fillInputsGooglePlaces = (addressComponents, suffix = '') => {
  const { route, country, country_long, street_number, postal_code, postal_town, locality } = addressComponents;
  let countryDropdown = document.querySelector('[name="state_extra"]');
  if (suffix !== '_extra') {
    countryDropdown = document.querySelector(`[name="country${suffix ? '_2' : '_1'}"]`);
    if (countryDropdown) {
      const dropdown = countryDropdown.closest('.dropdown');
      const selectedCountry = dropdown.querySelector(`[data-type="${country}"]`);
      if (selectedCountry) {
        dropdown.querySelector('.dropdown__placeholder-text').innerHTML = selectedCountry.dataset.title;
        selectedCountry.click();
        dropdown.classList.add('is-selected');
      }
    }
    addClassAndValue(`[name="address${suffix}"]`, `${route} ${street_number}`);
    addClassAndValue(`[name="post${suffix}"]`, postal_code);
  } else {
    countryDropdown.closest('.mod-input').classList.add('is-focused');
    countryDropdown.value = country_long;
    addClassAndValue(`[name="address_1${suffix}"]`, `${route} ${street_number}`);
    addClassAndValue(`[name="postcode${suffix}"]`, postal_code);
  }
  addClassAndValue(`[name="city${suffix}"]`, postal_town || locality);
  resetShippingDropVariant();
};
const initializeGooglePlacesSearch = () => {
  const inputIds = ['#address', '#address_diff', '#address_1_extra'];
  inputIds.forEach((inputId) => {
    const input = document.querySelector(inputId);
    if (input) {
      const options = {};
      switch (localData.lang) {
        case 'sl':
          options.componentRestrictions = { country: 'si' };
          break;
        case 'hr':
          options.componentRestrictions = { country: 'hr' };
          break;
        default:
          options.componentRestrictions = {};
          break;
      }
      const autocomplete = new google.maps.places.Autocomplete(input, options);
      google.maps.event.addListener(autocomplete, 'place_changed', () => {
        const addressComponents = {
          postal_code: '',
          street_number: '',
          country: '',
          country_long: '',
          route: '',
          postal_town: '',
          locality: '',
        };
        const place = autocomplete.getPlace();
        place.address_components.forEach((component) => {
          const [type] = component.types;
          if (addressComponents[type] !== undefined) {
            addressComponents[type] = type === 'country' ? component.short_name : component.long_name;
            if (type === 'country') {
              addressComponents.country_long = component.long_name;
            }
          }
        });
        if (addressComponents.street_number === '') {
          const inputValueParts = input.value.split(',');
          addressComponents.route = inputValueParts.length > 0 ? inputValueParts[0] : input.value;
        }
        fillInputsGooglePlaces(
          addressComponents,
          input.id === 'address_1_extra' ? '_extra' : input.id === 'address' ? '' : '_diff',
        );
      });
    }
  });
};
const hideSidebar = () => {
  const processSidebar = document.querySelector('.purchase-process-sidebar');
  if (processSidebar && window.innerWidth < 1023) {
    const content = processSidebar.querySelector('.purchase-process-sidebar__content');
    slideUp(content, 300);
    processSidebar.classList.remove('is-open');
  }
};
// GA4 add_shipping_info / add_payment_info: vsak dogodek enkrat na izbiro
const dataLayerSent = { shipping: '', payment: false };
const getShippingTier = () => {
  if (document.querySelector('#delivery-type')?.checked) return 'Prevzem';
  const delivery = document.querySelector('input[name="delivery"]:checked');
  if (!delivery) return '';
  const label = delivery.closest('label') || document.querySelector(`label[for="${delivery.id}"]`);
  return (label && label.textContent.replace(/\s+/g, ' ').trim()) || delivery.dataset.code || delivery.value;
};
const pushShippingInfo = () => {
  const tier = getShippingTier();
  if (!tier || dataLayerSent.shipping === tier) return;
  dataLayerSent.shipping = tier;
  window.prowDL.pushEcommerce('add_shipping_info', { ...window.prowDL.dl.cart, shipping_tier: tier });
};
const pushPaymentInfo = () => {
  if (dataLayerSent.payment) return;
  dataLayerSent.payment = true;
  window.prowDL.pushEcommerce('add_payment_info', window.prowDL.dl.cart);
};

const hideAllSteps = () => {
  steps.forEach((item) => {
    item.hidden = true;
  });
};
const showStep = (step) => {
  steps.forEach((item) => {
    if (item.classList.contains(step)) {
      item.hidden = false;
    }
  });
};
const getActiveStep = () => {
  let active = 0;
  steps.forEach((item) => {
    if (item.hidden === false) {
      const [result] = item.id.match(/\d+/);
      active = result;
    }
  });
  return active;
};

const getInputData = () => {
  const formData = {};
  // eslint-disable-next-line consistent-return
  const getInputDataIn = (input) => {
    if (input.type !== 'checkbox' && input.type !== 'radio') {
      return input.value.trim();
    }
    if (input.checked) {
      return input.dataset.title || input.dataset.text || input.id.trim();
    }
  };
  document.querySelectorAll('input, textarea, select').forEach((input) => {
    const getValue = getInputDataIn(input);
    if (getValue !== undefined && getValue !== '' && getValue !== 'on' && input.name) {
      formData[input.name] = getValue;
    }
  });
  formData.shipping_country_code = getUserAddressCode();
  return formData;
};

let stripe;
let stripeElement;
let elements;
if (document.querySelector('.sc-purchase-process-info-03') && typeof localData === 'object') {
  stripe = Stripe(localData.stripeKey, {
    locale: localData.lang,
  });
}

const initializeStripe = () => {
  document.querySelector('#payment-element').innerHTML = '';
  const axiosData = new FormData();
  axiosData.append('action', 'createStripeClientKey');
  axiosData.append('inputs', JSON.stringify(getInputData()));
  axios
    .post(localData.apiURL, axiosData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      if (response.status === 200) {
        localData.clientSecret = response.data.clientSecret;
        elements = stripe.elements({ clientSecret: response.data.clientSecret });
        const paymentElement = elements.create('payment');
        paymentElement.mount('#payment-element');
      }
    });
};

const showMessage = (messageText) => {
  const messageContainer = document.querySelector('#payment-message');
  messageContainer.hidden = false;
  messageContainer.innerHTML = messageText;
};

const getSelectedPaymentMethod = () => {
  const selectedMethod = Array.from(document.querySelectorAll('input[name="payment-methods"]')).find(
    (item) => item.checked,
  );
  return selectedMethod ? selectedMethod.id : '';
};

async function handleSubmitStripe(token) {
  const { paymentIntent } = await stripe.retrievePaymentIntent(localData.clientSecret);
  const axiosData = new FormData();
  axiosData.append('action', 'createOrderFromCartItems');
  axiosData.append('type', 'stripe');
  axiosData.append('token', token);
  axiosData.append('stripePaymentIntentId', paymentIntent.id);
  axiosData.append('stripePaymentIntentSecret', paymentIntent.client_secret);
  axiosData.append('inputs', JSON.stringify(getInputData()));
  await axios.post(localData.apiURL, axiosData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  const { error } = await stripe.confirmPayment({
    elements,
    confirmParams: {
      return_url: `${localData.apiURL}?action=updateOrderStatus`,
    },
  });
  setTimeout(() => {
    toggleLoaderClass(loading, false);
  }, 2000);
  if (error.type === 'card_error' || error.type === 'validation_error') {
    showMessage(localData.translations.payment_error);
  } else {
    showMessage('An unexpected error occurred.');
  }
}
const handleSubmitMoney = (token, type) => {
  const axiosData = new FormData();
  axiosData.append('action', 'createOrderFromCartItems');
  axiosData.append('type', type === 'cash-money' ? 'money' : type);
  axiosData.append('token', token);
  axiosData.append('inputs', JSON.stringify(getInputData()));
  axios.post(localData.apiURL, axiosData).then((response) => {
    window.location.href = response.data.data.url;
    setTimeout(() => {
      toggleLoaderClass(loading, false);
    }, 2000);
  });
};

const handleSubmitPaypal = (status) => {
  toggleLoaderClass(loading, true);
  grecaptcha.ready(() => {
    grecaptcha.execute(localData.captchaSiteKey, { action: 'createOrderFromCartItems' }).then((token) => {
      const axiosData = new FormData();
      axiosData.append('action', 'createOrderFromCartItems');
      axiosData.append('type', 'paypal');
      axiosData.append('token', token);
      axiosData.append('inputs', JSON.stringify(getInputData()));
      axiosData.append('paypal-status', JSON.stringify(status));
      axiosData.append('paypal_pre_order_id', localData.paypal_pre_order_id || 0);
      axiosData.append('order_key', localData.order_key || 0);
      axios
        .post(localData.apiURL, axiosData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((response) => {
          if (response.status === 200) {
            window.location.href = response.data.data.url;
          }
          setTimeout(() => {
            toggleLoaderClass(loading, false);
          }, 3000);
        });
    });
  });
};

const initializePayPal = () => {
  document.querySelector('.btn-paypal').innerHTML = '';
  const axiosData = new FormData();
  axiosData.append('action', 'createPayPalAmount');
  axiosData.append('inputs', JSON.stringify(getInputData()));
  axios
    .post(localData.apiURL, axiosData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      if (response.status === 200) {
        window.paypal
          .Buttons({
            createOrder(data, actions) {
              return actions.order.create({
                application_context: {
                  shipping_preference: 'NO_SHIPPING',
                },
                purchase_units: [
                  {
                    amount: {
                      value: response.data.amount,
                    },
                  },
                ],
              });
            },
            onClick(data, actions) {
              const formData = new FormData();
              formData.append('action', 'createOrderFromCartItems');
              formData.append('inputs', JSON.stringify(getInputData()));
              formData.append('token', JSON.stringify(data));
              formData.append('type', 'paypal');
              formData.append('pre_order', 'true');
              return fetch(localData.apiURL, {
                method: 'POST',
                body: formData,
              })
                .then((res) => res.json())
                .then((data) => {
                  if (data.data.order_id) {
                    localData.paypal_pre_order_id = data.data.order_id;
                    localData.order_key = data.data.order_key;
                    return actions.resolve();
                  }
                  return actions.reject();
                });
            },
            onApprove(data, actions) {
              return actions.order.capture().then((status) => {
                handleSubmitPaypal(status);
              });
            },
            onError: (err) => {
              showMessage(err);
            },
          })
          .render('.btn-paypal');
      }
    });
};

const reInitExpress = () => {
  const axiosData = new FormData();
  axiosData.append('action', 'createPayPalAmount');
  axiosData.append('inputs', JSON.stringify(getInputData()));
  axiosData.append('without_shipping', true);
  axios
    .post(localData.apiURL, axiosData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      stripeElement.update({
        amount: Number(response.data.amount),
      });
    });
};

const reInitPayMethods = () => {
  document.querySelectorAll('input[name="payment-methods"]:checked').forEach((item) => {
    if (item.id === 'credit-card') {
      initializeStripe();
    }
    if (item.id === 'paypal-payment') {
      initializePayPal();
    }
  });
  reInitExpress();
};

const changeSidBarPrice = (data) => {
  const axiosData = new FormData();
  axiosData.append('action', 'getSidePriceHtml');
  axiosData.append('data', JSON.stringify(data));
  axios
    .post(localData.apiURL, axiosData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      document.querySelector('.purchase-process-prices').innerHTML = response.data.data;
      if (
        response.data.amount &&
        document.querySelector('.purchase-process-sidebar__header-price') &&
        response.data.amount.final.text__right
      ) {
        document.querySelector('.purchase-process-sidebar__header-price').innerHTML =
          response.data.amount.final.text__right;
      }
    });
};

const sendPerksData = () => {
  const paymentInputs = document.querySelectorAll('input[name="payment-methods"]');
  paymentInputs.forEach((input) => (input.disabled = true));
  const perks = getCheckedPerks();
  const axiosData = new FormData();
  axiosData.append('action', 'addPerksToCart');
  axiosData.append('perks', JSON.stringify(perks));
  axios
    .post(localData.apiURL, axiosData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      if (response.data.delivery.shipping_price) {
        document
          .querySelector('#sc-purchase-process-info-02 input[name="delivery"]:checked')
          .closest('.purchase-process-dropdown__item')
          .querySelector('.purchase-process-dropdown__item-price').innerHTML = response.data.delivery.shipping_price;
      }
      changeSidBarPrice(response.data);
      reInitPayMethods();
    })
    .then(() => {
      setTimeout(() => {
        paymentInputs.forEach((input) => (input.disabled = false));
      }, 1000);
    });
};

const createAddressValidator = () => ({
  validators: {
    regexp: {
      regexp: /.*\d/,
      message: localData.translations.address_warning,
    },
  },
});

const eventHandleCheckoutForm = (form) => {
  const emailError = getEmailError(form);

  const fv = FormValidation.formValidation(form, {
    locale: 'sl_SI',
    localization: FormValidation.locales.sl_SI,
    fields: {
      'delivery-type': {
        validators: {
          notEmpty: {
            message: localData.translations.delivery_warning,
          },
        },
      },
      'payment-methods': {
        validators: {
          notEmpty: {
            message: localData.translations.payment_warning,
          },
        },
      },
      privacy: {
        validators: {
          notEmpty: {
            message: localData.translations.privacy_warning,
          },
        },
      },
      contact_mail: {
        validators: {
          regexp: {
            regexp: '^[^@\\s]+@([^@\\s]+\\.)+[^@\\s]+$',
            message: emailError,
          },
        },
      },
      address: createAddressValidator(),
      address_diff: createAddressValidator(),
      address_1_extra: createAddressValidator(),
    },
    plugins: {
      message: new FormValidation.plugins.Message({
        container: (field, element) => {
          const parentElement = element.closest(
            '.mod-input, .purchase-process-dropdowns__item-dropdowns, .checkbox[data-component="at-checkbox"]',
          );
          return parentElement || element;
        },
      }),
      declarative: new FormValidation.plugins.Declarative({
        html5Input: true,
      }),
      trigger: new FormValidation.plugins.Trigger({
        event: 'submit',
      }),
      excluded: new FormValidation.plugins.Excluded(),
      submitButton: new FormValidation.plugins.SubmitButton({
        // eslint-disable-next-line no-shadow
        buttons(form) {
          const stepForm = form.closest('.steps-process');
          return [].slice.call(
            stepForm.querySelectorAll(
              'button.btn--dark, .breadcrumbs__link[data-action], .purchase-process__address-contact__change, .edit-address-form__submit button',
            ),
          );
        },
      }),
    },
  }).on('core.element.validated', (e) => {
    // e.element presents the field element
    // e.valid indicates the field is valid or not
    if (e.element.hasAttribute('required')) {
      // Get the field value
      const value = fv.getElementValue(e.field, e.element);
      const container = FormValidation.utils.closest(
        e.element,
        '.mod-input,.purchase-process-dropdowns__item-dropdowns,.checkbox[data-component="at-checkbox"],.dropdown[data-component="at-dropdown"]',
      );
      FormValidation.utils.classSet(container, {
        'is-validation-failed': value.trim() === '' || !e.valid,
      });
    }
  });
};

const getUserAddress = () => {
  if (document.querySelector('#different_address').checked) {
    const formDifferentAddress = document
      .querySelector('#different_address')
      .closest('.purchase-process-form__checkbox-dropdowns');
    return `${formDifferentAddress.querySelector('#address_diff').value} ${
      formDifferentAddress.querySelector('#post_diff').value
    } ${formDifferentAddress.querySelector('#city_diff').value}`;
  }
  if (document.querySelector('.purchase-process-form__addresses-main')) {
    return document.querySelector('.purchase-process-form__addresses__right').innerHTML;
  }
  const formAddress = document.querySelector('.sc-purchase-process-info-01');
  return `${formAddress.querySelector('#address').value} ${formAddress.querySelector('#post').value} ${
    formAddress.querySelector('#city').value
  }`;
};

const getUserAddressCode = () => {
  if (document.querySelector('#different_address').checked && document.querySelector('[name="country_2"]:checked')) {
    return document.querySelector('[name="country_2"]:checked').value;
  }
  if (document.querySelector('.purchase-process-form__addresses-main')) {
    return document.querySelector('.purchase-process-form__addresses-main').dataset.code;
  }
  if (document.querySelector('[name="country_1"]:checked')) {
    return document.querySelector('[name="country_1"]:checked').value;
  }
  return 'SI';
};

const saveContactInfoToCookie = () => {
  if (document.querySelector('#save_for_next_time').checked) {
    const inputValues = {};
    const inputs = document.querySelectorAll('#contact_email, .purchase-process-form__inputs input');
    inputs.forEach((input) => {
      if (input.type === 'text' || input.type === 'email') {
        inputValues[input.id] = input.value;
      } else if (input.type === 'radio' && input.checked) {
        inputValues[input.name] = input.dataset.type;
      }
    });
    Cookies.set('users_data', JSON.stringify(inputValues), true, { expires: 31 });
  } else {
    document.cookie = 'users_data=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  }
};

const fillUserDataFromCookie = () => {
  const cookie = Cookies.get('users_data');
  if (cookie) {
    const jsonData = JSON.parse(cookie);
    const inputs = document.querySelectorAll('#contact_email, .purchase-process-form__inputs input');
    inputs.forEach((input) => {
      if (input.type === 'radio' && jsonData.country_1 === input.dataset.type) {
        const dropdown = input.closest('.dropdown');
        const selectedCountry = dropdown.querySelector(`[data-type="${jsonData.country_1}"]`);
        if (selectedCountry) {
          dropdown.querySelector('.dropdown__placeholder-text').innerHTML = selectedCountry.dataset.title;
          selectedCountry.click();
          dropdown.classList.add('is-selected');
        }
      } else if ((input.type === 'text' || input.type === 'email') && input.closest('.mod-input')) {
        input.closest('.mod-input').classList.add('is-focused');
        input.value = jsonData[input.id];
      } else if (input.name === 'save_for_next_time') {
        input.checked = true;
      }
    });
  }
};

const changeDynamicUserData = (goToStep) => {
  const userDelivery = document.querySelector('[name="delivery"]:checked');
  steps.forEach((item) => {
    if (item.querySelector('.mail-contact')) {
      item.querySelector('.mail-contact').innerHTML = document.querySelector('#contact_email').value;
    }
    if (item.querySelector('.address-contact')) {
      item.querySelector('.address-contact').innerHTML = getUserAddress();
    }
    if (item.querySelector('.delivery-contact') && userDelivery) {
      item.querySelector('.delivery-contact').innerHTML = userDelivery
        .closest('.purchase-process-dropdown__item')
        .querySelector('.purchase-process-dropdown__item-title').innerText;
    }
  });
  if (userDelivery && document.querySelector('.sc-purchase-process-info-03 .checkbox__info-price')) {
    document.querySelector('.sc-purchase-process-info-03 .checkbox__info-price').innerHTML =
      userDelivery.dataset.price !== null && userDelivery.dataset.price !== undefined ? userDelivery.dataset.price : '';
  }
  resetGiftInputs();
  if (goToStep === 'sc-purchase-process-info-02') {
    if (document.querySelector('#save_for_next_time')) {
      saveContactInfoToCookie();
    }
    // if (!document.querySelector('#send_email')) {
    //   document.querySelector('#delivery-type').click();
    // }
  }
  const stepNumber = parseInt(goToStep.split('-').pop(), 10);
  document.querySelectorAll('.purchase-process__indicator-icon').forEach((el, index) => {
    el.classList.remove('is-active', 'is-done');
    if (index + 1 < stepNumber) {
      el.classList.add('is-done');
    } else if (index + 1 === stepNumber) {
      el.classList.add('is-active');
    }
  });
};
const preventShippingToHrSl = (goToStep) => {
  const mainAddress = document.querySelector(
    '.purchase-process-form__addresses .purchase-process-form__addresses-main, .purchase-process-form__inputs .dropdown.text--gray-79',
  );
  if (!mainAddress) {
    return true;
  }
  let isValid = true;
  if (
    (goToStep === 'sc-purchase-process-info-02' || goToStep === 'sc-purchase-process-info-03') &&
    (localData.lang === 'sl' || localData.lang === 'hr')
  ) {
    if (getUserAddressCode() !== (localData.lang === 'sl' ? 'SI' : 'HR')) {
      mainAddress.scrollIntoView({ behavior: 'smooth', block: 'start' });
      mainAddress.classList.add('is-validation-failed');
      isValid = false;
    } else {
      mainAddress.classList.remove('is-validation-failed');
    }
  }
  return isValid;
};

const resetGiftInputs = () => {
  const allInputs = document.querySelectorAll('.purchase-process-sidebar__content .is-validation-failed');
  allInputs.forEach((input) => input.classList.remove('is-validation-failed'));
};

const resetShippingDropVariant = () => {
  const allShipping = document.querySelectorAll('.purchase-process-dropdown input[name="delivery"][data-code]');
  const deliveryTypeCheckbox = document.querySelector('#delivery-type');
  if (deliveryTypeCheckbox) {
    const dropdownDrop = deliveryTypeCheckbox
      .closest('.purchase-process-dropdown')
      .querySelector('.purchase-process-dropdown__drop');

    const userCode = getUserAddressCode();
    allShipping.forEach((i) => {
      const closestItem = i.closest('.purchase-process-dropdown__item');
      closestItem.hidden = !(
        i.dataset.code === userCode ||
        (userCode !== 'HR' && userCode !== 'SI' && i.dataset.code === 'OTHER')
      );
      i.checked = false;
    });
    dropdownDrop.setAttribute('style', 'box-sizing: border-box; display: none;');
    deliveryTypeCheckbox.checked = false;
  }
};

const getCheckedPerks = () => {
  const perks = {};
  orderPerks.forEach((item) => {
    const checkbox = document.querySelectorAll(item);
    checkbox.forEach((ch) => {
      if (ch.checked) {
        perks[ch.name] = ch.id;
      }
    });
  });
  return perks;
};

const initExpressCheckout = () => {
  const formDataInput = new FormData();
  formDataInput.append('action', 'createPayPalAmount');
  formDataInput.append('just_return_amount', true);
  formDataInput.append('without_fee', true);
  formDataInput.append('inputs', JSON.stringify(getInputData()));
  axios
    .post(localData.apiURL, formDataInput, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      stripeElement = stripe.elements({
        mode: 'payment',
        amount: response.data.amount,
        currency: 'eur',
      });
      const expressCheckoutElement = stripeElement.create('expressCheckout', {
        buttonType: {
          googlePay: 'checkout',
          applePay: 'check-out',
          paypal: 'paypal',
        },
        layout: {
          maxRows: 1,
        },
      });
      const fastPaymentItems = document.querySelector('.purchase-process-form__fast-payment__items');
      const loaderDiv = fastPaymentItems?.querySelector('.purchase-process-form__fast-payment__loader');
      const expressDiv = fastPaymentItems?.querySelector('.purchase-process-form__fast-payment__express');
      if (expressDiv) {
        expressCheckoutElement.mount(expressDiv);
        expressDiv.style.opacity = '0';
      }
      expressCheckoutElement.on('ready', () => {
        setTimeout(() => {
          if (fastPaymentItems) {
            fastPaymentItems.style.minHeight = `${fastPaymentItems.offsetHeight}px`;
          }
          if (loaderDiv) {
            loaderDiv.style.opacity = '0';
            loaderDiv.style.pointerEvents = 'none';
          }
          if (expressDiv) {
            expressDiv.style.opacity = '1';
          }
        }, 2000);
      });
      expressCheckoutElement.on('shippingaddresschange', (event) => {
        const filteredData = localData.shipping.slice(0, 9);
        event.resolve({
          shippingRates: filteredData,
        });
      });
      expressCheckoutElement.on('click', (event) => {
        event.resolve({
          emailRequired: true,
          shippingAddressRequired: true,
          shippingRates: localData.shipping,
          phoneNumberRequired: true,
        });
      });
      expressCheckoutElement.on('confirm', async (event) => {
        toggleLoaderClass(loading, true);
        const { error: submitError } = await stripeElement.submit();
        const handleError = (error) => {
          const messageContainer = document.querySelector('#error-message');
          messageContainer.hidden = false;
          messageContainer.textContent = error.message;
          setTimeout(() => {
            messageContainer.hidden = true;
          }, 15000);
          toggleLoaderClass(loading, false);
        };
        if (submitError) {
          handleError(submitError);
          return;
        }
        const formDataInputRes = new FormData();
        formDataInputRes.append('action', 'createPayPalAmount');
        formDataInputRes.append('create_stripe_secret', true);
        formDataInputRes.append('express_checkout_data', JSON.stringify(event));
        formDataInputRes.append('inputs', JSON.stringify(getInputData()));
        try {
          const res = await axios.post(localData.apiURL, formDataInputRes, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          });
          const { client_secret: clientSecret, url } = res.data;
          const { error } = await stripe.confirmPayment({
            [event.expressPaymentType === 'paypal' ? 'stripeElement' : 'elements']: stripeElement,
            clientSecret,
            confirmParams: {
              return_url: url,
            },
          });
          if (error) {
            handleError(error);
          }
        } catch (postError) {
          handleError(postError);
        }
      });
    })
    .catch((error) => {
      console.error(error);
    });
};

document.addEventListener('DOMContentLoaded', () => {
  if (!document.querySelector('.sc-purchase-process-info-01')) {
    return;
  }
  window.addEventListener('pageshow', (event) => {
    const navigationEntries = performance.getEntriesByType('navigation');
    if (
      event.persisted ||
      (window.performance && navigationEntries.length > 0 && navigationEntries[0].type === 'back_forward')
    ) {
      window.location.reload();
    }
  });
  document.querySelectorAll('input[name="country_1"], input[name="country_2"]').forEach((item) => {
    item.addEventListener('change', resetShippingDropVariant);
  });
  document.querySelectorAll('.saved-address').forEach((ch) => {
    ch.addEventListener('click', resetShippingDropVariant);
  });
  ['sc-purchase-process-info-01', 'sc-purchase-process-info-02', 'sc-purchase-process-info-03'].forEach((id) => {
    const form = document.querySelector(`#${id}`);
    if (form !== null) {
      eventHandleCheckoutForm(form.querySelector('form'));
    }
  });
  orderPerks.forEach((checkers) => {
    const checkboxes = document.querySelectorAll(checkers);
    checkboxes.forEach((item) => {
      item.addEventListener('click', () => {
        setTimeout(() => {
          sendPerksData();
        }, 200);
      });
    });
  });
  document
    .querySelectorAll('a[data-action]:not(.login--checkout), button[data-action]:not(.login--checkout)')
    .forEach((el) => {
      el.addEventListener('click', (e) => {
        const stepWantToGo = Number(e.target.dataset.action.match(/\d+/)[0]);
        const activeStep = Number(getActiveStep());
        let goToStep = e.target.dataset.action;
        if (!preventShippingToHrSl(goToStep)) {
          return;
        }
        if (!e.target.closest('.steps-process').querySelector('.is-validation-failed') || stepWantToGo <= activeStep) {
          if (stepWantToGo === 3 && activeStep === 1 && !document.querySelector('#delivery-type').checked) {
            // prevent to skip second step from first one
            goToStep = 'sc-purchase-process-info-02';
          }
          const newAddressContainer = document.querySelector('.new-address');
          if (
            activeStep === 1 &&
            newAddressContainer &&
            newAddressContainer.classList.contains('is-active') &&
            document.querySelector('#address_1_extra').value
          ) {
            // prevent to go to second step if "add new address" form is open with all inputs inside
            document
              .querySelector('.purchase-process-form__addresses')
              .scrollIntoView({ behavior: 'smooth', block: 'start' });
            return;
          }
          changeDynamicUserData(goToStep);
          hideSidebar();
          hideAllSteps();
          showStep(goToStep);
          if (goToStep === 'sc-purchase-process-info-03') pushShippingInfo();
          document.querySelector('main').scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        if (document.querySelector('.is-validation-failed')) {
          document.querySelector('.is-validation-failed').scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    });
  document.querySelectorAll('#credit-card').forEach((item) => {
    item.addEventListener('click', () => {
      sendPerksData();
    });
  });
  document.querySelectorAll('.edit-address-form__submit button').forEach((item) => {
    item.addEventListener('click', async (ev) => {
      ev.preventDefault();
      const form = item.closest('.purchase-process-form__address-edit-hidden-form');
      if (form.querySelector('.is-validation-failed')) {
        return;
      }
      const inputs = {};
      const formInputs = form.querySelectorAll('input');
      formInputs.forEach((input) => {
        inputs[input.name.replace('_extra', '')] = input.value;
      });
      try {
        const token = await grecaptcha.execute(localData.captchaSiteKey, { action: 'userAddAddress' });
        const response = await axios.post(
          localData.apiURL,
          {
            token,
            action: 'userAddAddress',
            nonce: inputs.nonce,
            inputs: JSON.stringify(inputs),
            lang: localData.lang,
            id: localData.id,
            html: true,
          },
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          },
        );
        formInputs.forEach((input) => {
          input.value = '';
        });
        const newAddressCheck = document.querySelector('.purchase-process-form__address.new-address');
        newAddressCheck.insertAdjacentHTML('beforebegin', response.data.data.html);
        newAddressCheck.classList.remove('is-active');
        newAddressCheck.querySelector('.purchase-process-form__address-edit-hidden-form').removeAttribute('style');
        pickAddresses();
        pasteAddress();
        document.querySelector('#id-address').value = response.data.data.addressID;
        document.querySelector('.purchase-process-form__addresses-main.is-active').dataset.code =
          response.data.data.code;
        document.querySelector(
          '.purchase-process-form__addresses-main .purchase-process-form__addresses__right',
        ).innerHTML = response.data.data.address;
        resetShippingDropVariant();
        document.querySelector('.saved-address.is-active').addEventListener('click', () => {
          resetShippingDropVariant();
        });
      } catch (error) {
        console.error(error);
      }
    });
  });
  document.querySelectorAll('#paypal-payment').forEach((item) => {
    item.addEventListener('click', () => {
      sendPerksData();
    });
  });
  document.querySelectorAll('.sc-purchase-process-info-03 button[type="submit"]').forEach((item) => {
    item.addEventListener('click', (ev) => {
      if (!ev.target.closest('.purchase-process-form').querySelector('.is-validation-failed')) {
        ev.preventDefault();
        const paymentMethod = getSelectedPaymentMethod();
        pushShippingInfo();
        pushPaymentInfo();
        grecaptcha.ready(() => {
          if (!document.querySelector('.site-loader.is-loading')) {
            toggleLoaderClass(loading, true);
            document.querySelector('#payment-message').hidden = true;
            grecaptcha.execute(localData.captchaSiteKey, { action: 'createOrderFromCartItems' }).then((token) => {
              if (paymentMethod === 'credit-card') {
                handleSubmitStripe(token);
              } else if (paymentMethod === 'invoice') {
                handleSubmitMoney(token, paymentMethod);
              }
            });
          }
        });
      }
    });
  });
  window.addEventListener('load', () => {
    initializeGooglePlacesSearch();
    resetShippingDropVariant();
    fillUserDataFromCookie();
    initExpressCheckout();
    // GA4 begin_checkout (podatki košarice s strežnika: getDataLayerCart)
    window.prowDL.pushEcommerce('begin_checkout', window.prowDL.dl.cart);
  });
});
